/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import classnames from 'classnames';
import * as React from 'react';

export interface ISignUpErrorProps {
    id?: string;
    className: string;
    type?: string;
    message?: string;
}

const SignUpError: React.FC<ISignUpErrorProps> = ({ id, className, type = 'page', message }) => {
    const errorClassName = `${className}__${type}-error`;

    return (
        <div id={id} className={classnames(errorClassName, 'error', `${type}Level`)} role='alert' aria-live='assertive' aria-hidden='true'>
            {message ? (
                <p className={`${errorClassName}-text`} dangerouslySetInnerHTML={{ __html: message }} />
            ) : (
                <p className={`${errorClassName}-text`}></p>
            )}
        </div>
    );
};

export default SignUpError;
